import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import styled from 'styled-components';

const Label = styled(FormControlLabel)`
  margin-left: 0;
  background-color: #f9f9f9;
  padding-right: 15px;
  border-bottom: 3px solid ${props => props.color || '#f9f9f9'};
`;

const LabelledCheckbox = ({label, checked, onChange, color, ...props}) => (
  <Label
    color={color}
    control={
      <Checkbox
        color="primary"
        checked={checked}
        onChange={onChange}
      />
    }
    label={label}
    {...props}
  />
);

LabelledCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  color: PropTypes.string,
};

export default LabelledCheckbox;
